/* eslint-disable no-param-reassign */
import { find } from 'underscore';
import { getMediaPlacementType } from './get-media-placement-type';

export function updatePlacementWithBaseCropSettings({
  placement,
  mtImgObject,
  IsCroppingbasedOriginal = false,
  setCroppingType = false,
}) {
  if (mtImgObject.CropSettingOnOriginal) {
    const { SourceX, SourceY } = mtImgObject.CropSettingOnOriginal;

    placement.BaseImage.setCropSettings(mtImgObject.CropSettingOnOriginal);
    placement.BaseImage.src = mtImgObject.OriginalUrl;
    placement.BaseImage.height = mtImgObject.OriginalHeight;
    placement.BaseImage.width = mtImgObject.OriginalWidth;

    placement.src = mtImgObject.OriginalUrl;
    placement.height = mtImgObject.OriginalHeight;
    placement.width = mtImgObject.OriginalWidth;

    if (!IsCroppingbasedOriginal) {
    // transform any auto/smart cropping back to the dimensions of the original image
      placement.cropSettings.SourceX += SourceX;
      placement.cropSettings.SourceY += SourceY;
    }

    if (setCroppingType) {
      // bulk cropping are all manual crop
      placement.cropSettings.CroppingType = 'ManualCrop';
    }
  }
}

export function updatePlacementWithPlacementSettings({
  isMultimediaAd,
  isMultimediaAdinMSANEnabled,
  isCombinedMsanAndMmaAspectRatios,
  isPMaxAspectRatiosV2Enabled,
  placement,
  mtImgObject,
  updatePlacementSettings,
  setCroppingType = false,
}) {
  if (updatePlacementSettings &&
    mtImgObject.PlacementSettings && mtImgObject.PlacementSettings.length > 0) {
    const currentType = getMediaPlacementType({
      isMultimediaAd,
      isMultimediaAdinMSANEnabled,
      isCombinedMsanAndMmaAspectRatios,
      isPMaxAspectRatiosV2Enabled,
      type: placement.type,
    });
    const { CropSetting } =
      find(mtImgObject.PlacementSettings, ({ MediaPlacementType }) => (
        MediaPlacementType === currentType
      )) || {};
    if (CropSetting) {
      placement.setCropSettings(CropSetting);

      if (setCroppingType) {
        // bulk cropping are all manual crop
        placement.cropSettings.CroppingType = 'ManualCrop';
      }
    }
  }
}
